import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, computed, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { ConnectedPosition, OverlayModule } from '@angular/cdk/overlay';
import { MatDialog } from '@angular/material/dialog';
import { ChangeNamePopupComponent } from '../change-name-popup/change-name-popup.component';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { combineLatest, debounceTime, map, tap } from 'rxjs';
import { StepActionsComponent } from '../step-actions/step-actions.component';
import { AnswersStore, StatusValidation } from 'src/app/store/answers-store';
import { toSignal } from '@angular/core/rxjs-interop';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
    selector: 'que-step',
    imports: [CommonModule, TranslateDirective, TranslatePipe, OverlayModule, StepActionsComponent, SvgIconComponent],
    templateUrl: './step.component.html',
    styleUrls: ['./step.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StepComponent implements OnInit {

  @Input() stepName?: string;
  @Input() index!: number;
  @Input() isCurrent = false;
  @Input() isData = false;
  @Input() isPreview = false;

  @ViewChild('trigger') trigger!: ElementRef;
  #answersStore = inject(AnswersStore);
  eStatusValidation = StatusValidation;

  dd = toSignal(this.#answersStore.validCurrentAllStep$);
  index$ = signal<number | undefined>(undefined);
  statusValidStep$ = this.#answersStore.validCurrentAllStep$.pipe(map(validAllSteps => validAllSteps.find(v => v.index == this.index)?.statusStepValidation));

  visitedSteps$ = toSignal(this.#answersStore.visitedSteps$)
  currentStepIndex$ = toSignal(this.#answersStore.currentStepIndex$)
  isVisitedStep$ = computed(() => { this.currentStepIndex$(); return this.index$() != undefined ? this.visitedSteps$()?.includes(this.index$()!) : false; });
  isShowError$ = toSignal(this.#answersStore.showIndication$);

  isUser$ = toSignal(inject(QuestionnaireStore).isUser$);
  isMenuStepOpen = false;

  ngOnInit(): void {
    this.statusValidStep$ = this.#answersStore.validCurrentAllStep$.pipe(
      map(
        (validAllSteps) => {
          return validAllSteps.find(v => v.index == this.index)?.statusStepValidation;
        }));
    this.index$.set(this.index);
  }

  readonly positonArea = [{
    originX: 'end',
    originY: 'bottom',
    overlayX: 'center',
    overlayY: 'top',
  }] as ConnectedPosition[];

  closeMenu() {
    this.isMenuStepOpen = false;
  }

  openMenu() {
    // event.stopPropagation();
    const triggerRect = this.trigger.nativeElement.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    // Check if the menu would open out of the viewport
    if (triggerRect.bottom + 250 > viewportHeight) { // assuming 200px height for the menu
      this.positonArea[0].overlayY = 'bottom';
    } else {
      this.positonArea[0].overlayY = 'top';
    }
    this.isMenuStepOpen = true;
  }
}
